// extracted by mini-css-extract-plugin
module.exports = {"UiBannerCard__icon":"cards_UiBannerCard__icon__5H5u2","UiMenuCard__icon":"cards_UiMenuCard__icon__duA3H"};